import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=6d1fdec9&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1fdec9",
  null
  
)

export default component.exports